(function () {
    'use strict';

    angular
        .module('physicalFairs')
        .controller('PhysicalFairAcceptedInvoicesController', PhysicalFairAcceptedInvoicesController);
    PhysicalFairAcceptedInvoicesController.$inject = ['$uibModal', 'ExpoService', 'CitiesByExpoService', 'PhysicalFairService', 'AdmService'];
    function PhysicalFairAcceptedInvoicesController($uibModal, ExpoService, CitiesByExpoService, PhysicalFairService, AdmService) {
        var vm = this;

        vm.flag                         = false;
        vm.commentsResult               = [];
        vm.expoSelected                 = [];
        vm.sellers                      = [];
        vm.sellerSelected               = [];
        vm.i                            = -1;
        vm.selectExpo                   = selectExpo;
        vm.getByFilter                  = getByFilter;
        vm.selectRepresentativesByExpo  = selectRepresentativesByExpo;

        /*PAGINATION*/
        vm.pageChanged           = pageChanged;
        vm.setPage               = setPage;
        vm.to                    = [];
        vm.totalItems            = [];
        vm.currentPage           = null;
        vm.itemsPerPage          = [];
        vm.page                  = 1;
        vm.invoiceStatus         = [{'status' : null, 'name' : 'All'},{'status' : 1, 'name' : 'Accepted'},{'status' : 0, 'name' : 'Not Accepted'}];
        vm.invoiceStatusSelected = [];
        vm.invoices              = [];

        function activate() {
            vm.selectExpo();
            vm.selectRepresentativesByExpo();
        }

        function selectExpo () {
            ExpoService.getExpos().then(function(response){
                 vm.expo = response.data;
            }).catch(function(err) {
            });
        }

        function selectRepresentativesByExpo () {
            vm.query = {};
            /*
            vm.query['expo_id'] = vm.expoSelected.id;
            PhysicalFairService.getRepresentativesByExpo(vm.query).then(function(response){
                vm.sellers = response.data;
            }).catch(function(err) {
            });
            */
            AdmService.getSellers().then(function(response){
                vm.sellers = response.data;
            }).catch(function(err) {
            });
        }

        function getByFilter() {
            vm.flag = false;
            vm.query = {};
            if(typeof vm.expoSelected !== 'undefined') {
                vm.query['expo_id'] = vm.expoSelected.id;
            }
            if(typeof vm.sellerSelected !== 'undefined') {
                vm.query['seller_id'] = vm.sellerSelected.id;
            }

            if(typeof vm.invoiceStatusSelected !== 'undefined') {
                vm.query['status'] = vm.invoiceStatusSelected.status;
            }
            if(vm.page !== null)
                vm.query['page'] = vm.page;

            PhysicalFairService.getAcceptedInvoices(vm.query).then(function(response){
                vm.invoices = response.data.data;
                vm.flag = true;
                if(vm.invoices.length == 0){
                    vm.noResultMessage = 'Sorry, no results were found!';
                    vm.flag = false;
                } else {
                    vm.noResultMessage = '';
                    vm.flag = true;
                }
                vm.totalItems = response.data.total;
                vm.to         = response.data.to;
                vm.setPage(response.data.current_page);
                vm.itemsPerPage = response.data.per_page;
            }).catch(function(err){
            });
        }

        function setPage (pageNo) {
            vm.currentPage = pageNo;
        }

        function pageChanged (pageNo) {
            vm.page = vm.currentPage;
            vm.getByFilter();
        }

        activate();
    }
})();